import React, { useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import UnitDisplay from './UnitDisplay';
import UnitsColumnView from './UnitsColumnView';
import AddNewUnit from './AddNewUnit';
import UnitEdit from './UnitEdit';
import UnitsExport from './utilities/UnitsExport';
import UnitsImport from './utilities/UnitsImport';
import { loadUnits } from '../../redux/actions/unitActions';
import { loadUsers, loadCheckinModes } from '../../redux/actions/userActions';
import { getSiteInfo } from '../../redux/actions/systemActions';
// import AssociateAlarmDeviceToUnit from "./AssociateAlarmDeviceToUnit";

/**
 * The function to display the appropriate components for units.
 * @description - React Router takes the url paths and displays the appropriate components. If the route is /units/ it will display the list of units. If the Route is /units/ followed by a number, it will display the full view of that user. If it's /units/edit/ followed by a number, it will display the edit view for that unit
 */

function Units(props) {
  const location = useLocation();
  const { state, pathname } = location;
  const previousLocation = useRef(location);

  useEffect(() => {
    props.dispatch(loadUnits());
    props.dispatch(loadUsers());
    props.dispatch(loadCheckinModes());
    props.dispatch(getSiteInfo());
  }, []); // eslint-disable-line

  if (state && state.modal) {
    if (
      pathname === '/units/addUnit/' ||
      pathname === '/units/export/' ||
      pathname === '/units/import/'
    ) {
      previousLocation.current = { pathname: '/units/' };
    }
  }

  useEffect(() => {
    if (location) {
      if (state && state.modal) {
        previousLocation.current = { pathname: '/units/' };
      } else {
        previousLocation.current = location;
      }
    }
  }, [location, state]);

  let isModal = false;
  if (state && state.modal) {
    isModal = true;
  }

  return (
    <React.Fragment>
      {/* The Routes is used to set the background to display underneath the overlay component. It checks to see if the url being loaded involves a modal and uses the route found in the previousLocation ref to set the contents of the Routes */}
      <Routes location={isModal ? previousLocation.current : location}>
        <Route
          index
          element={<UnitsColumnView />}
          data-test="units-route"
        />
        <Route
          path=":id/view"
          element={<UnitDisplay />}
          data-test="view-route"
        />
        <Route
          path="addUnit"
          element={<AddNewUnit />}
          data-test="add-route"
        />
        <Route
          path=":id/edit"
          element={<UnitEdit />}
          data-test="edit-route"
        />
        <Route
          path="export"
          element={<UnitsExport />}
          data-test="units-export-route"
        />
        <Route
          path="import"
          element={<UnitsImport />}
          data-test="units-import-route"
        />
      </Routes>
    </React.Fragment>
  );
}
export default connect()(Units);
